import 'react-app-polyfill/ie11';

import * as React from "react";
import * as ReactDOM from "react-dom";
import {ContactForm} from "./components/ContactForm";
import {Slideshow} from "./components/Slideshow";
import {DealerNews} from "./components/Dealer/News";

// @ts-ignore
(window as any).react = {
    react_render_contact_form: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <ContactForm recipient={config.recipient} trn={config.trn} color={config.color} type={config.type}/>,
                target
            );
        }
    },

    react_slideshow: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <Slideshow config={config}/>,
                target
            );
        }
    },

    react_dealer_news: function (target: any, config: any) {
        if (target) {
            return ReactDOM.render(
                <DealerNews lang={config.lang} table_cols={config.table_cols} meta_fields={config.meta_fields}
                            category={config.category} dealer_id={config.dealer_id} trn={config.trn}/>,
                target
            );
        }
    },

};